export default "__VITE_ASSET__8309dd22__"